import type { ReactNode } from 'react';

export interface KpiCardProps {
  label: string;
  value: ReactNode;
  secondary?: ReactNode;
  trend?: ReactNode;
  accent?: 'default' | 'success' | 'warning' | 'danger';
  onClick?: () => void;
}

const KpiCard = ({ label, value, secondary, trend, accent = 'default', onClick }: KpiCardProps) => {
  const className = [`kpi-card`, `kpi-card--${accent}`, onClick ? 'kpi-card--interactive' : ''].filter(Boolean).join(' ');

  const body = (
    <>
      <header className="kpi-card__label">{label}</header>
      <div className="kpi-card__value">{value}</div>
      {secondary && <div className="kpi-card__secondary">{secondary}</div>}
      {trend && <div className="kpi-card__trend">{trend}</div>}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick} aria-label={label}>
        {body}
      </button>
    );
  }

  return (
    <article className={className}>{body}</article>
  );
};

export default KpiCard;
